import LazyLoadImage from '@bnnvara/lazy-load';
import { Tag } from '@bnnvara/tags';
import PropTypes from 'prop-types';
import React from 'react';
import * as S from './styled';
const LandscapeImageCard = /*#__PURE__*/React.forwardRef(({
  thumbnail,
  tag,
  title,
  brandName,
  pubDate,
  description
}, ref) => /*#__PURE__*/React.createElement(S.CardWrapper, {
  ref: ref
}, thumbnail && /*#__PURE__*/React.createElement(S.CardImageContainer, null, /*#__PURE__*/React.createElement(LazyLoadImage, {
  as: S.CardImage,
  src: thumbnail,
  alt: `Afbeelding van ${title}`
})), tag && /*#__PURE__*/React.createElement(S.CardTag, null, /*#__PURE__*/React.createElement(Tag, {
  type: "primary"
}, tag)), /*#__PURE__*/React.createElement(S.CardBody, null, /*#__PURE__*/React.createElement("span", null, title), (brandName || pubDate) && /*#__PURE__*/React.createElement(S.CardMeta, null, brandName && /*#__PURE__*/React.createElement(React.Fragment, null, brandName, " \u2022 "), pubDate && pubDate), description && /*#__PURE__*/React.createElement(S.Description, null, description))));
LandscapeImageCard.defaultProps = {
  tag: null,
  brandName: null,
  description: null,
  pubDate: null
};
LandscapeImageCard.propTypes = {
  thumbnail: PropTypes.string.isRequired,
  tag: PropTypes.string,
  title: PropTypes.string.isRequired,
  brandName: PropTypes.string,
  description: PropTypes.string,
  pubDate: PropTypes.string
};
export default LandscapeImageCard;